/* eslint-disable */
import React from 'react';
import {
  Text,
  StyleSheet,
  View,
  TouchableWithoutFeedback,
  Picker,
  TouchableHighlight,
} from 'react-native'

const styles = StyleSheet.create({
  overlay: {
    position: 'fixed',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    backgroundColor: 'white',
    zIndex: 11,
    paddingTop: 5,
  },
  
  overlayInner: {
    height: '100%',
    maxHeight: 580,
  },
  
  cancelContainer: {
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 40,
    alignItems: 'center',
  },
  
  option: {
    textAlign: 'center',
    fontSize: 25,
    marginBottom: 25,
    color: 'black',
  },
  
  cancel: {
    padding: 20,
  },
  
  cancelIcon: {
    fontSize: 40,
    color: 'black',
  },
  
  heading: {
    marginTop: 25,
    marginBottom: 30,
    fontWeight: '600',
    fontSize: 12,
    textAlign: 'center',
    color: 'black',
  },
})

export default class SelectionOverlay extends React.Component {
  constructor(props) {
    super(props)
    
    this.state = {
    }
  }
  
  onSelect(option) {
    this.props.onSelect(option.value)
  }
  
  onCancel() {
    this.props.onCancel()
  }
  
  render() {
    return (
      <View style={[styles.overlay, {display: this.props.show ? 'flex' : 'none'}]}>
        <View style={styles.overlayInner}>
          {this.props.heading &&
            <Text style={styles.heading}>{this.props.heading.toUpperCase()}</Text>
          }
          
          {this.props.options.map((option, index) => (
            <Text
              style={styles.option}
              key={index}
              onPress={this.onSelect.bind(this, option)}>
              
              {option.label}
            </Text>
          ))}
        
          {this.props.ableToClose &&
          <View style={styles.cancelContainer}>
            <TouchableWithoutFeedback onPress={this.onCancel.bind(this)}>
              <View style={styles.cancel}>
                <Text style={styles.cancelIcon}>╳</Text>
              </View>
            </TouchableWithoutFeedback>
          </View>
          }
        </View>
      </View>
    )
  }
}
